import React from 'react';
import { Box, Typography, Button, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import ReceiptIcon from '@mui/icons-material/Receipt';
import SummarizeIcon from '@mui/icons-material/Summarize';
import CustomCard from '../../Shared/Components/CustomCard/CustomCard';
import { CashDocumentsList, CashBalanceWidget, CashReportsList } from '../Components';

/**
 * Main page for Cash Documents (KP/KW)
 * Shows balance widget + full list with filters
 */
const CashDocumentsPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box>
      {/* Header with Create Button */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h4" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <ReceiptIcon color="primary" fontSize="large" />
          Dokumenty kasowe (KP/KW)
        </Typography>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => navigate('/cash-documents/create')}
        >
          Nowy dokument
        </Button>
      </Box>

      <Stack spacing={3}>
        {/* Balance Widget */}
        <CashBalanceWidget
          defaultCurrency="PLN"
          showCurrencySelector={true}
          defaultRangeDays={30}
        />

        <CustomCard title="Cykle raportów kasowych" icon={<SummarizeIcon color="primary" />}>
          <CashReportsList />
        </CustomCard>

        {/* Documents List */}
        <CustomCard title="Lista dokumentów" icon={<ReceiptIcon color="primary" />}>
          <CashDocumentsList showFilters={true} />
        </CustomCard>
      </Stack>
    </Box>
  );
};

export default CashDocumentsPage;
